enum Colors {
  PRIMARY_MAIN = '#6A5DCC',
  PRIMARY_SHADE = '#988DEA',
  PRIMARY_ACCENT = '#3E3D59',
  PRIMARY_LIGHT = '#988DEA29',

  SECONDARY_MAIN = '#0EABBC',
  SECONDARY_SHADE = '#42D1E0',
  SECONDARY_LIGHT = '#42D1E014',

  DANGER_MAIN = '#D6584D',
  DANGER_SHADE = '#F6857B',

  WARNING_MAIN = '#F2AD27',
  WARNING_SHADE = '#FFCE6F',

  BLUE = '#1976d2',
  COLOR_DARK_1 = '#000000',
  COLOR_DARK_2 = '#202329',
  COLOR_DARK_3 = '#555B68',
  COLOR_DARK_3_05 = '#555B68',
  COLOR_DARK_4 = '#9D9FA4',
  COLOR_DARK_5 = '#E8E8E8',
  COLOR_DARK_6 = '#F6F6F6',

  WHITE = '#FFFFFF',
  COLOR_WHITE_2 = '#E8E8E8',
  COLOR_WHITE_3 = '#F2F2F2',
  COLOR_WHITE_TEXT = '#FEFEFE',

  COLOR_ICON_GREY = '#808998',
}

export default Colors;
